import api, {graphqlQueryBuild} from '../../services/api';

export const VIDEO_PREPARE_START = 'VIDEO_PREPARE_START';
export const VIDEO_PREPARE_SUCCESS = 'VIDEO_PREPARE_SUCCESS';
export const VIDEO_PREPARE_ERROR = 'VIDEO_PREPARE_ERROR';
export const VIDEO_PREPARE_CLEAR = 'VIDEO_PREPARE_CLEAR';
export const VIDEO_CAN_AUTOPLAY = 'VIDEO_CAN_AUTOPLAY';

export const preparePlayback = videoId => async (dispatch, getState) => {
    let {config, user} = getState();

    dispatch({type: VIDEO_PREPARE_START, id: videoId});

    let url = `${(config.catalog_settings &&
        config.catalog_settings.endpoint) ||
        'https://avs-proxy.dev.aaa.wmgp.io/v1'}/A/${user.catalogLanguage ||
        'spa'}/${(config.catalog_settings &&
        config.catalog_settings.platforms[0]) ||
        'PCTV_DASH'}/${user.catalogTenant ||
        'CNPLUS_LATAM_LATAM'}/content/cdn/?id=${videoId}&type=VOD&asJson=Y`;

    let headers = new Headers();

    let response = await fetch(url, {headers})
        .then(res => {
            if (!res.ok) {
                throw new Error('Playback request failed');
            }
            return res.json();
        })
        .then(res => {
            dispatch({
                type: VIDEO_PREPARE_SUCCESS,
                payload: res.resultObj,
                id: videoId,
            });

            return res;
        })
        .catch(error => {
            dispatch({type: VIDEO_PREPARE_ERROR, error, id: videoId});

            return error;
        });

    return response;
};

export const preparePlaybackFreeContent = videoId => async dispatch => {
    dispatch({type: VIDEO_PREPARE_START, id: videoId});

    let query = graphqlQueryBuild(
        'playback',
        `
        drmToken
        url    
        `,
        `id: ${videoId}`,
    );

    let response = await api
        .get('', {
            params: {
                query,
            },
        })
        .then(res => {
            if (res.status !== 200) {
                throw new Error('Playback request failed');
            }

            return res;
        })
        .then(res => {
            dispatch({
                type: VIDEO_PREPARE_SUCCESS,
                payload: res.resultObj,
                id: videoId,
            });

            return res;
        })
        .catch(error => {
            dispatch({type: VIDEO_PREPARE_ERROR, error, id: videoId});

            return error;
        });

    return response;
};

export const interactedWithApp = () => async dispatch => {
    dispatch({type: VIDEO_CAN_AUTOPLAY, autoplay: true});
};
